import { LoadPageAction } from '../../../common/actions/LoadPageAction';
import { LoadPagePayload } from '../../../common/actions/LoadPagePayload';

export function getQueryListType<TModel>(module: string, type: { new(): TModel; }): string {
  return `[${module}] Query List of ${(type as any).$typeName}`;
}

export class QueryListAction<TModel> implements LoadPageAction {
  readonly identifier = new Date().getTime().toString();
  readonly type: string;

  constructor(module: string, modelType: { new(): TModel; }, public payload: LoadPagePayload) {
    this.type = getQueryListType(module, modelType);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/store/actions/QueryListAction.ts